import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

const KEY = 'vd_cookie_consent_v1';

const CookieBanner = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem(KEY)) {
      const t = setTimeout(() => setVisible(true), 900);
      return () => clearTimeout(t);
    }
  }, []);

  const accept = () => {
    localStorage.setItem(KEY, JSON.stringify({ accepted: true, at: Date.now() }));
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="fixed bottom-4 inset-x-4 sm:inset-x-auto sm:right-4 sm:max-w-md z-40 bg-white/95 backdrop-blur-md border border-vd-soft rounded-2xl shadow-lg p-5 vd-fade" data-testid="cookie-banner">
      <p className="text-xs text-vd-muted leading-relaxed mb-3">
        Ta stran uporablja piškotke, ki so nujni za njeno delovanje. Z uporabo strani se strinjaš s{' '}
        <Link to="/politika-zasebnosti" className="underline text-vd-accent">politiko zasebnosti</Link>.
      </p>
      <button
        onClick={accept}
        className="w-full bg-vd-accent text-white text-sm rounded-full py-2 hover:opacity-90 transition-all"
        data-testid="cookie-accept"
      >
        V redu, razumem
      </button>
    </div>
  );
};

export default CookieBanner;
